"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const getMobileOS = () => {
    const userAgent = navigator.userAgent || navigator.vendor;
    const isIOS = userAgent.match(/iPad/i) || userAgent.match(/iPhone/i) || userAgent.match(/iPod/i);
    const isAndroid = userAgent.match(/Android/i);
    return isIOS ? 'IOS' : (isAndroid ? 'Android' : 'unknown');
};
exports.default = getMobileOS;
